<template>
  <div class="content" :style="styleObject">
    <div class="security-box">
      <img class="logo-img" src="@/assets/images/login.png" />
      <div class="login-text" v-if="$store.getters.authorityRoute == '/parent'">
        Welcome to Online Application System
      </div>
      <div class="login-text" v-else>
        Welcome to Application System Admin Portal
      </div>
      <div class="addUser-description">開設戶口 Create Account</div>
      <div class="addUser-text">
 <div >Please complete the entire application procedures on a personal computer.</div>
      <div > 請使用個人電腦完成整個申請程序。</div>
      <div >After pressing the "Submit" button, please activate your account. 
Please check the email inbox that you have just registered; and click the verification link in the email within 15 minutes.</div>
      <div > 請使用個人電腦完成整個申請程序。按下 "提交" 鍵後，請啟動你的電郵帳戶。
請檢查你剛登記的電郵帳戶, 並在15分鐘內點擊電郵內的驗證連結。</div>
      </div>
     
      <el-form
        label-position="top"
        :rules="rules"
        ref="ruleForm"
        label-width="180px"
        :model="formLabelAlign"
      >
        <el-form-item label="電郵 Email" prop="email">
          <el-input v-model="formLabelAlign.email" placeholder="Email">
            <template slot="prepend"><i class="el-icon-message"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item label="密碼 Password:" prop="password">
          <el-input
            show-password
            v-model="formLabelAlign.password"
            placeholder="Password"
          >
            <template slot="prepend"><i class="el-icon-view"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item label="確認密碼 Confirm Password:" prop="confirmPassword">
          <el-input
            show-password
            v-model="formLabelAlign.confirmPassword"
            placeholder="Confirm Password"
          >
            <template slot="prepend"><i class="el-icon-view"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onSubmit">提 交 Submit</el-button>
          <el-button type="primary" @click="onBack">返 回 Return</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="reserved-text">
      Copyright by HKCCCU Logos Academy. All rights reserved.
    </div>
    <loadingDialog :center-dialog-visible="centerDialogVisible"></loadingDialog>
  </div>
</template>
  
  <script>
import { getSetting } from "@/api/parent/setting";
import { addUser } from "@/api/parent/user";
import loadingDialog from "@/components/loadingDialog/index";
export default {
  components: { loadingDialog },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("The password cannot be empty.密碼不能為空。"));
      } else {
        if (this.formLabelAlign.confirmPassword !== "") {
          this.$refs.ruleForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("The password cannot be empty.密碼不能為空。"));
      } else if (value !== this.formLabelAlign.password) {
        callback(
          new Error(
            "The password and its confirm are not the same.密碼和確認密碼不一致。"
          )
        );
      } else {
        callback();
      }
    };
    return {
      styleObject: {
        backgroundImage: "",
      },
      centerDialogVisible: false,
      formLabelAlign: {
        email: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "The Email cannot be empty  郵箱不能為空",
            trigger: "blur",
          },
          {
            type: "email",
            message: "郵箱格式不正確 The E-mail format is incorrect",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          { validator: validatePass, trigger: "blur" },
          {
            min: 8,
            message: "The password must be at least 8 digits.密碼至少8位。",
            trigger: "blur",
          },
        ],
        confirmPassword: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  watch: {
    setting: {
      handler(v) {
        if (v != null) {
          this.styleObject.backgroundImage = `url(${this.setting.backgroundImage1})`;
        }
      },
      deep: true,
    },
  },
  created() {
    this.getSetting();
  },
  methods: {
    getSetting() {
      getSetting().then((v) => {
        this.setting = v.data;
      });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.addUser();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addUser() {
      this.centerDialogVisible = true;
      let form = {
        email: this.formLabelAlign.email,
        password: this.formLabelAlign.password,
        confirmPassword: this.formLabelAlign.confirmPassword,
      };
      addUser(form)
        .then(() => {
          this.$message({
          message: "戶口已經開設，”請到收件箱/雜件箱等查看電郵及啟動帳户。” *The account has been created, please check your inbox/spam folder, etc. for the email and activate your account.",
          type: "success",
          customClass: "message-zindex",
        });
          this.onBack();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.content {
  height: 100% !important;
  background-color: #070060;
  background-image: url("~@/assets/images/bg.png");
  background-size: 100%;
  background-position: center;
  position: relative;
  background-repeat: no-repeat;
}
.security-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  height: 100% !important;
}
.el-form {
  width: 400px;
  display: block;
  margin-right: 30px;
}
.el-form-item {
  color: #fff !important;
}
.addUser-text {
  color: #fff;
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.reserved-text {
  color: #fff;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.forgot-text {
  color: #2eac00;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
}
.addUser-description {
  color: #72acff;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 25px;
}
.login-text {
  color: #fff;
  font-size: 40px;
  margin-top: 20px;
  margin-bottom: 10px;
}
::v-deep {
  .el-form--label-top .el-form-item__label {
    color: #fff !important;
  }
  .el-button--info {
    width: 100%;
    background-color: #337ab7;
    border-color: #337ab7;
    margin-left: 0;
    margin-bottom: 10px;
  }
  .el-button--primary {
    width: 100%;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.logo-img {
  display: block;
  width: 368px;
  margin: 0 auto;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .content{
    height: auto !important;
  }
  .security-box{
    height: auto !important;
  }
  .login-text{
    font-size: 1.25rem;
  }
  .addUser-description{
    font-size: 1.25rem;
  }
  .logo-img{
    width: auto;
    margin-left: 0;
  }
  .el-form{
    width: auto;
    margin-right: 0;
  }
  .reserved-text{
    bottom: 0;
    position: relative;
    text-align: center;
  }
}
</style>